module.exports = __webpack_public_path__ + "static/media/squire-logo.21c8c1ef.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/squire-logo.svg
// module id = 1314
// module chunks = 0